import React, { Component, PropTypes } from 'react';
import { Field } from 'redux-form';
import { Link } from 'react-router';
import classnames from 'classnames';
import omit from 'lodash/omit';
import {
  TextInputField, EmailInputField, SelectField, BasicTextAreaField, DateInputField
} from 'common/components/form_fields';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import { trackGoogle } from 'common/tracking';
import IntercomChat from 'common/containers/intercom_chat';
import { trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME } from 'common/tracking';

class Contact extends Component {

  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    trackGoogle("contact", "viewed contact form", "contact");
    trackMixpanel(
      MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
      {
        "pageName": "Contact us"
      }
    )
  }

  submitForm(values) {
    trackGoogle("contact", "submitted contact form", "contact");
    trackMixpanel("Submitted contact form", {});
    const data = values.category === 'award'? values : omit(values, 'payment_request_date');
    this.props.onSubmit(data);
  }

  render() {
    const {
      onSubmit, handleSubmit, isLoading, success, canChatOrCall, showingChat,
      toggleChat, questionCategories, selectedCategory
    } = this.props;
    const classes = classnames('help-content contact-page', { succeeded: success });

    return (
      <div className={classes}>
        <Meta
          title="Contact | Help | crowdspring"
          meta={[
            { name: 'description', content: "How to contact crowdspring - find answers, call, chat or email us, 24/7" },
            { name: "keywords", content: "crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing" }
          ]}
          link={[{ rel: "canonical", href: getCanonicalURL(`/help/contact/`) }]}
        />
        <div className="row">
          <div className="columns small-16 medium-10 large-12">
            <section className="contact-form">
              <div className="row align-center">
                <div className="small-16 medium-16 large-10 columns">
                  <div className="contact-success">

                    <h3><i className="fa fa-check-circle"/> Message Sent!</h3>
                    <h2>Now what?</h2>
                    <p>
                      Our customer service team has received your message and you&apos;ll hear back from them shortly,
                      usually within 24 hours.
                    </p>
                    <p>
                      In the meantime, find answers to frequently asked questions in our <a href="/help">Help Center</a>.
                    </p>
                  </div>
                  <form onSubmit={handleSubmit(this.submitForm)} >
                    <div className="form-intro">
                      <h2>Email us anytime.</h2>
                      <p>We&apos;d love to hear from you. We&apos;re&nbsp;here to help,
                      and we&nbsp;don&apos;t like to brag, but we&apos;re pretty good at it!
                      (99%&nbsp;satisfaction&nbsp;rate with our customer service) <br className="show-for-large"/>If you have a technical question, be&nbsp;sure to check out our <Link to="/help/">Help&nbsp;Center</Link> first.</p>
                    </div>
                    <Field name="full_name" component={TextInputField} label="Full name" />
                    <Field name="email" component={EmailInputField} label="Email" />
                    <Field name="category" component={SelectField} label="How can we help you?"
                      allowEmpty={true} options={questionCategories} />
                    { selectedCategory === 'award' &&
                    <Field name="payment_request_date" component={DateInputField}
                      label="What date did you request the payment you're writing about?" /> }
                    <Field name="message" component={BasicTextAreaField} label="Message"
                      formClasses="message-box" minRows={4}/>
                    <button className="btn btn-tertiary btn-block" type="submit"
                      disabled={isLoading}>
                      { isLoading ? "Sending..." : "Send" }
                    </button>
                  </form>
                </div>
              </div>
            </section>
          </div>
          <aside className="small-16 medium-6 large-4 columns sidebar">

            <section>
              <h2>Customer Support Hours</h2>
              <p>Monday–Friday<br/>
              9:00am–5:00pm CT</p>
              { canChatOrCall &&
              <ul className="contact-links">
                <li><a href="tel:877.887.7442" onClick={trackGoogle.bind(null, "contact", "clicked phone number", "contact", null, null)}><i className="fa fa-fw fa-phone"/> 877.887.7442</a></li>
                <li>
                  <a onClick={toggleChat}>
                    <i className="fa fa-fw fa-comments-o" /> { showingChat && 'Close' } Chat
                  </a>
                </li>
              </ul> }
            </section>

            <section>
              <h2>Social</h2>
              <ul className="social-links">
                <li><a href="https://www.facebook.com/crowdspring/" rel="nofollow noopener noreferrer" target="_blank"><i className="fa fa-fw fa-facebook"/> Friend Us</a></li>
                <li><a href="https://twitter.com/crowdspring" rel="nofollow noopener noreferrer" target="_blank"><i className="fa fa-fw fa-twitter"/> Follow @crowdspring</a></li>
              </ul>
            </section>

          </aside>
        </div>
        { showingChat && <IntercomChat expandOnShow={true} /> }
      </div>);
  }
};

Contact.propTypes = {
  canChatOrCall: PropTypes.bool,
  showingChat: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  toggleChat: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  success: PropTypes.bool,
  selectedCategory: PropTypes.string,
  questionCategories: PropTypes.array.isRequired,
};

export default Contact;



// WEBPACK FOOTER //
// ./help/components/contact.jsx